<template>
  <div class="tgh-title-page">
    <h1>{{ title }}</h1>
    <p>{{ desc }}</p>
  </div>
</template>

<script>
export default {
  name: 'TitlePage',
  props : ['title','desc']
}
</script>
